import { createContext, Dispatch } from 'react'

import { ReducerAction } from 'utility-tools/module/reducers'
import { TOverrideType } from 'utility-tools/module/types'
import { IReducerContextProps } from 'utility-tools/module/reducers'

enum WarningReducerAction {
    SHOW_WARNING = 'SHOW_WARNING',
    HIDE_WARNING = 'HIDE_WARNING',
}

type TWarningState = {
    show: boolean
    message: string
}

const initialWarningState: TWarningState = {
    message: '',
    show: false,
}

class ShowWarningAction extends ReducerAction<string> {
    constructor(message: string) {
        super(WarningReducerAction.SHOW_WARNING, message)
    }
}

class HideWarningAction extends ReducerAction<WarningReducerAction> {
    constructor() {
        super(WarningReducerAction.HIDE_WARNING)
    }
}

type TWarningActions = ShowWarningAction | HideWarningAction

const warningReducer = (
    state: TWarningState = initialWarningState,
    action: TWarningActions,
): TWarningState => {
    const { type, payload } = action

    switch (type) {
        case WarningReducerAction.SHOW_WARNING: {
            return <TWarningState>{
                ...state,
                message: payload,
                show: true,
            }
        }
        case WarningReducerAction.HIDE_WARNING: {
            return <TWarningState>{
                ...state,
                message: '',
                show: false,
            }
        }
        default:
            return state
    }
}

type TCookieControlContext = TOverrideType<
    IReducerContextProps,
    {
        state: TWarningState
        dispatchAction?: Dispatch<TWarningActions>
    }
>

const WarningContext = createContext<TCookieControlContext>({
    state: initialWarningState,
})

export type { TWarningActions }
export { WarningContext, warningReducer, initialWarningState, ShowWarningAction, HideWarningAction }
